import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { ActionsRender } from './components/actions-render';
import { ActionsRenderProps, WithAdditionalType } from './components/actions-render/types';
import { BaseTable, BaseTableProps } from './components/base-table';
import { ACTION_KEY } from './constants';
import { ColumnDefinitionInterface } from './types/column-interface';
import { resolveRowId } from './utils';
export type TableProps<T, K> = Omit<BaseTableProps<T>, 'renderMobileRow' | 'renderTabletRow'> & Partial<Omit<ActionsRenderProps<T, K>, 'instance'>> & {
  /**
   * Replaces the labelled column stack inside the mobile card with a hand-composed layout. The
   * actions menu of the row is passed in so the card can place it itself.
   */
  renderMobileRow?: (row: T, actions: React.ReactNode) => React.ReactNode;
  /** Optional tablet layout; otherwise preserves the mobile renderer or default mobile cards. */
  renderTabletRow?: (row: T, actions: React.ReactNode) => React.ReactNode;
};
export function Table(t0) {
  const $ = _c(33);
  let actions;
  let actionsOrder;
  let caption;
  let columns;
  let getRowId;
  let renderMobileRow;
  let renderTabletRow;
  let restProps;
  let testAttributePostfix;
  if ($[0] !== t0) {
    ({
      testAttributePostfix,
      getRowId,
      actions,
      caption,
      columns,
      actionsOrder,
      renderMobileRow,
      renderTabletRow,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = actions;
    $[2] = actionsOrder;
    $[3] = caption;
    $[4] = columns;
    $[5] = getRowId;
    $[6] = renderMobileRow;
    $[7] = renderTabletRow;
    $[8] = restProps;
    $[9] = testAttributePostfix;
  } else {
    actions = $[1];
    actionsOrder = $[2];
    caption = $[3];
    columns = $[4];
    getRowId = $[5];
    renderMobileRow = $[6];
    renderTabletRow = $[7];
    restProps = $[8];
    testAttributePostfix = $[9];
  }
  let t1;
  if ($[10] !== actions || $[11] !== actionsOrder || $[12] !== caption || $[13] !== getRowId || $[14] !== testAttributePostfix) {
    t1 = instance => actions && Object.keys(actions).length > 0 ? <ActionsRender caption={caption} actions={actions} instance={instance as WithAdditionalType<T, K>} rowId={resolveRowId({
      row: instance,
      getRowId
    })} testAttributePostfix={testAttributePostfix} actionsOrder={actionsOrder} /> : null;
    $[10] = actions;
    $[11] = actionsOrder;
    $[12] = caption;
    $[13] = getRowId;
    $[14] = testAttributePostfix;
    $[15] = t1;
  } else {
    t1 = $[15];
  }
  const renderActions = t1;
  let t2;
  if ($[16] !== actions || $[17] !== columns || $[18] !== renderActions) {
    t2 = actions && Object.keys(actions).length > 0 ? [...columns, {
      key: ACTION_KEY,
      header: "",
      className: "!w-18",
      onRender: instance_0 => renderActions(instance_0)
    }] : columns;
    $[16] = actions;
    $[17] = columns;
    $[18] = renderActions;
    $[19] = t2;
  } else {
    t2 = $[19];
  }
  const columnsWithActions = t2;
  let t3;
  if ($[20] !== renderActions || $[21] !== renderMobileRow) {
    t3 = renderMobileRow ? row => renderMobileRow(row, renderActions(row)) : undefined;
    $[20] = renderActions;
    $[21] = renderMobileRow;
    $[22] = t3;
  } else {
    t3 = $[22];
  }
  let t4;
  if ($[23] !== renderActions || $[24] !== renderTabletRow) {
    t4 = renderTabletRow ? row_0 => renderTabletRow(row_0, renderActions(row_0)) : undefined;
    $[23] = renderActions;
    $[24] = renderTabletRow;
    $[25] = t4;
  } else {
    t4 = $[25];
  }
  let t5;
  if ($[26] !== columnsWithActions || $[27] !== getRowId || $[28] !== restProps || $[29] !== t3 || $[30] !== t4 || $[31] !== testAttributePostfix) {
    t5 = <BaseTable getRowId={getRowId} columns={columnsWithActions} testAttributePostfix={testAttributePostfix} renderMobileRow={t3} renderTabletRow={t4} {...restProps} />;
    $[26] = columnsWithActions;
    $[27] = getRowId;
    $[28] = restProps;
    $[29] = t3;
    $[30] = t4;
    $[31] = testAttributePostfix;
    $[32] = t5;
  } else {
    t5 = $[32];
  }
  return t5;
}